"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageTitle = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Flex = require("../Flex/Flex");
var _PageTitle = require("./PageTitle.styles");
var _excluded = ["children", "heading"];
/**
 * The page title is used for the primary heading of the page, typically an `<h1>`.
 *
 * For cross-page consistency, the heading style is fixed, but you can still change the underlying
 * element with the `level` prop on `Heading`. If for some reason you need a different style,
 * you can simply use a `Heading` with the generic `PageContent` component.
 *
 * @related ['Heading']
 * @extends PageContent
 * @since 8.15.0
 */
var PageTitle = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    heading = _ref.heading,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var headingClone = /*#__PURE__*/(0, _react.cloneElement)(heading, {
    fontType: 'h3',
    fontFamily: 'serif'
  });
  return /*#__PURE__*/_react.default.createElement(_PageTitle.StyledPageTitle, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, null, headingClone), /*#__PURE__*/_react.default.createElement(_Flex.Flex, null, children)));
});
exports.PageTitle = PageTitle;
PageTitle.displayName = 'PageTitle';
PageTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Children content will be flexed to the end of the title row.
   */
  children: _propTypes.default.node,
  /**
   * A `Heading` component, typically
   * with `level={1}`. Note: `fontType` and `fontFamily` are fixed for this component for
   * consistent styles across pages.
   */
  heading: _propTypes.default.node.isRequired
} : {};